"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Badge2["default"];
  }
});
require("./Badge.scss");
var _Badge2 = _interopRequireDefault(require("react-bootstrap/lib/Badge"));


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/Badge.js
// module id = 715
// module chunks = 25